import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

// scripts/prerender.mjs stamps #root with the path whose landing it rendered
// ("/", "/uz" or "/ru"). The SPA fallback serves that same HTML for every other
// route too, so hydrate only when the prerendered path is the one being shown.
const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
const prerendered = rootEl.dataset.prerender;

if (prerendered && prerendered === pathname) {
  // Keep the server DOM: no re-render, no layout shift, no replayed animations.
  hydrateRoot(rootEl, <App />);
} else {
  // Any other route (sign-in, the portal, an unknown path): drop the landing
  // markup that was hidden pre-paint (see the `op-app` guard in index.html)
  // and render from scratch.
  rootEl.textContent = "";
  delete rootEl.dataset.prerender;
  document.documentElement.classList.remove("op-app");
  createRoot(rootEl).render(<App />);
}
